<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="close"
    >
      <el-form ref="author" :model="author" label-position="top">
        <el-form-item label="Name" prop="name">
          <el-input type="text" v-model="author.name" clearable />
        </el-form-item>
        <el-form-item label="Company" prop="company">
          <el-input type="text" v-model="author.company" clearable />
        </el-form-item>
        <div>
          <p class="inline-eye">Description</p>
          <i
            class="el-icon-view ml10"
            @click="openPreview(author.description)"
          ></i>
        </div>
        <el-form-item prop="description">
          <vue-editor
            v-model="author.description"
            :editorToolbar="customToolbar"
          />
        </el-form-item>
        <div>
          <p class="inline-eye">Bio</p>
          <i class="el-icon-view ml10" @click="openPreview(author.bio)"></i>
        </div>
        <el-form-item lprop="bio">
          <vue-editor v-model="author.bio" :editorToolbar="customToolbar" />
        </el-form-item>
        <div>
          <p class="inline-eye">Short bio</p>
          <i
            class="el-icon-view ml10"
            @click="openPreview(author.short_bio)"
          ></i>
        </div>
        <el-form-item prop="short_bio">
          <vue-editor
            v-model="author.short_bio"
            :editorToolbar="customToolbar"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit('author')"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from "vue2-editor"
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },
  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }
  },

  computed: {
    dialogTitle: function() {
      if (typeof this.author.id !== 'undefined' && this.author.id !== null)
        return 'Edit Blog Author'
      else return 'Insert Blog Author'
    },
    ...mapState('blogAuthor', [
      'loading',
      'author',
      'data',
      'dialog'   
    ])
  },

  methods: {
    ...mapActions('blogAuthor', ['update', 'insert']),
    ...mapMutations('blogAuthor', [
      'setSelectedAuthor',
      'setDialog'     
    ]),
    ...mapMutations('global', ['setPreview']),    

    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (typeof this.author.id !== 'undefined' && this.author.id !== null)
            this.update(this.author.id)
          else this.insert()
        } else {
          return false
        }
      })
    },

    onSuccess(response, file) {
      this.$message({
        type: 'success',
        message: `File ${file} uploaded`
      })
    },

    onError() {
      this.$message({
        type: 'error',
        message: 'Upload error'
      })
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    close() {
      this.setDialog(false)
    }
  }
}
</script>

<style scoped>
.inline-eye {
  display: inline-block;
}
</style>
